var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.88,63.66c-13.24,0-26.48,0-39.72,0c-1.87-0.86-3-2.15-3-4.36c0.03-16.23,0.01-32.47,0.02-48.7 c0-2.7,1.61-4.29,4.32-4.32c1.18-0.01,2.37,0,3.62,0c0-0.53,0-0.89,0-1.26c0.02-3.21,1.49-4.67,4.71-4.68 c8.56,0,17.12-0.02,25.69,0.03c0.66,0,1.46,0.3,1.95,0.73c3.5,3.08,6.93,6.25,10.41,9.35c0.67,0.6,0.97,1.18,0.96,2.1 c-0.05,4.86-0.02,9.72-0.02,14.59c0,8.12,0.01,16.23,0,24.35c0,2.61-1.64,4.22-4.27,4.24c-0.52,0.01-1.05,0-1.68,0 c0,1.02-0.07,1.92,0.01,2.81C52.09,60.98,51.14,62.69,48.88,63.66z M18.18,4.36c0,15.85,0,31.6,0,47.36c11.91,0,23.72,0,35.59,0 c0-12.52,0-24.98,0-37.57c-3.64,0-7.22,0-10.88,0c0-3.33,0-6.53,0-9.79C34.62,4.36,26.45,4.36,18.18,4.36z M10.23,10.3 c0,16.5,0,32.92,0,49.31c12.59,0,25.1,0,37.59,0c0-1.32,0-2.54,0-3.86c-0.51,0-0.95,0-1.4,0c-9.18,0-18.36,0-27.55,0 c-3.29,0-4.75-1.46-4.75-4.76c0-13.06,0-26.12,0-39.18c0-0.48,0-0.97,0-1.51C12.78,10.3,11.55,10.3,10.23,10.3z M50.64,10.18 c-1.33-1.2-2.44-2.2-3.66-3.29c0,1.27,0,2.27,0,3.29C48.16,10.18,49.25,10.18,50.64,10.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.16,22.16c9.25,0,18.41,0,27.65,0c0,1.27,0,2.49,0,3.81c-9.17,0-18.36,0-27.65,0 C22.16,24.76,22.16,23.51,22.16,22.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.82,30.11c0,1.3,0,2.52,0,3.8c-9.25,0-18.44,0-27.69,0c0-1.27,0-2.49,0-3.8 C31.32,30.11,40.51,30.11,49.82,30.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.12,41.81c0-1.3,0-2.52,0-3.8c9.25,0,18.44,0,27.69,0c0,1.27,0,2.49,0,3.8 C40.61,41.81,31.42,41.81,22.12,41.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.12,14.11c0-1.31,0-2.53,0-3.81c5.58,0,11.1,0,16.73,0c0,1.23,0,2.47,0,3.81 C33.32,14.11,27.77,14.11,22.12,14.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.4427a63be149dc2e081ddb325131febd.svg";
export { ForwardRef as ReactComponent };